/**
 * Cart drawer empty-state recommendations slider.
 * Loaded from cart-drawer.liquid so it always runs: inline scripts inside
 * cart-drawer-recommendations.liquid are not executed when that markup is
 * injected via section morph (e.g. after removing the last line item).
 */
(function () {
  if (!window.cartDrawerRecommendations) {
    window.cartDrawerRecommendations = {};
  }

  const sliderId = 'cart-drawer-recommendations-slider';
  const containerId = 'cart-drawer-recommendations-slider-container';

  if (!window.cartDrawerRecommendations.state) {
    window.cartDrawerRecommendations.state = {
      currentIndex: 0,
      itemsPerView: 1.2,
      sliderInstance: null,
    };
  }

  const state = window.cartDrawerRecommendations.state;

  function initSlider() {
    const slider = document.getElementById(sliderId);
    const container = document.getElementById(containerId);
    const prevButton = document.getElementById('cart-drawer-recommendations-prev');
    const nextButton = document.getElementById('cart-drawer-recommendations-next');

    if (!slider || !container) return;

    const items = container.querySelectorAll('.cart-drawer-recommendations-slider__item');
    if (items.length === 0) return;

    container.style.transform = '';

    function getStepWidth() {
      const firstItem = items[0];
      if (!firstItem) return slider.clientWidth * 0.85;
      const gap = parseFloat(window.getComputedStyle(container).gap || '10') || 10;
      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      const maxScrollLeft = Math.max(0, slider.scrollWidth - slider.clientWidth - 2);
      const atStart = slider.scrollLeft <= 2;
      const atEnd = slider.scrollLeft >= maxScrollLeft;

      if (prevButton) {
        prevButton.disabled = atStart;
        prevButton.style.opacity = atStart ? '0.35' : '1';
        prevButton.style.pointerEvents = atStart ? 'none' : 'auto';
      }
      if (nextButton) {
        nextButton.disabled = atEnd;
        nextButton.style.opacity = atEnd ? '0.35' : '1';
        nextButton.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
    }

    function slideNext() {
      slider.scrollBy({ left: getStepWidth(), behavior: 'smooth' });
    }

    function slidePrev() {
      slider.scrollBy({ left: -getStepWidth(), behavior: 'smooth' });
    }

    if (state.sliderInstance) {
      state.sliderInstance.destroy();
      state.sliderInstance = null;
    }

    if (nextButton) {
      nextButton.addEventListener('click', slideNext);
    }
    if (prevButton) {
      prevButton.addEventListener('click', slidePrev);
    }
    slider.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();

    state.sliderInstance = {
      next: slideNext,
      prev: slidePrev,
      update: updateButtons,
      destroy: function () {
        if (nextButton) nextButton.removeEventListener('click', slideNext);
        if (prevButton) prevButton.removeEventListener('click', slidePrev);
        slider.removeEventListener('scroll', updateButtons);
        window.removeEventListener('resize', updateButtons);
      },
    };
  }

  function tryInitSlider() {
    const slider = document.getElementById(sliderId);
    const container = document.getElementById(containerId);
    if (!slider || !container) return false;
    const items = container.querySelectorAll('.cart-drawer-recommendations-slider__item');
    if (!items || items.length === 0) return false;
    state.currentIndex = 0;
    initSlider();
    return true;
  }

  function tryInitSliderWithRetries(retryDelays) {
    retryDelays = retryDelays || [0, 50, 150, 350, 600];
    const timeouts = [];
    for (let i = 0; i < retryDelays.length; i++) {
      (function (delay) {
        const id = setTimeout(function () {
          if (tryInitSlider()) {
            timeouts.forEach(clearTimeout);
          }
        }, delay);
        timeouts.push(id);
      })(retryDelays[i]);
    }
  }

  window.cartDrawerRecommendations.tryInitSlider = tryInitSlider;
  window.cartDrawerRecommendations.tryInitSliderWithRetries = tryInitSliderWithRetries;

  function setup() {
    if (window.cartDrawerRecommendations.setupComplete) {
      tryInitSliderWithRetries();
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) {
      setTimeout(setup, 100);
      return;
    }

    const dialog = cartDrawer.querySelector('.cart-drawer__dialog');
    if (!dialog) {
      setTimeout(setup, 100);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      const dialogOpened = mutations.some(
        (m) => m.type === 'attributes' && m.attributeName === 'open' && dialog.open
      );

      const contentChanged = mutations.some(
        (m) => m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0)
      );

      if (dialogOpened || contentChanged) {
        if (contentChanged) {
          if (state.sliderInstance) {
            state.sliderInstance.destroy();
            state.sliderInstance = null;
          }
          state.currentIndex = 0;
        }
        requestAnimationFrame(() => {
          tryInitSliderWithRetries();
        });
      }
    });

    observer.observe(dialog, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true,
    });

    tryInitSliderWithRetries([0, 100, 300]);

    if (dialog.open) {
      tryInitSliderWithRetries();
    }

    function handleCartUpdate() {
      if (state.sliderInstance) {
        state.sliderInstance.destroy();
        state.sliderInstance = null;
      }
      state.currentIndex = 0;
      requestAnimationFrame(() => {
        tryInitSliderWithRetries([0, 100, 300, 500, 800]);
      });
    }

    if (typeof ThemeEvents !== 'undefined' && ThemeEvents.cartUpdate) {
      document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
    }
    document.addEventListener('cart:update', handleCartUpdate);
    document.addEventListener('cartUpdate', handleCartUpdate);

    window.cartDrawerRecommendations.setupComplete = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
